import { Steps } from "antd";
import React from "react";
import styled from "styled-components";
import color from "../../resource/color";

export const StepsStyled = styled(Steps)`
  .ant-steps-item-title {
    font-size: 14px;
    font-family: "IBM Plex Sans Thai", sans-serif;
  }
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    font-weight: 700;
    color: ${color.secondary} !important;
    // line-height: 18px !important;
  }
  .ant-steps-item-icon {
    font-family: "IBM Plex Sans Thai", sans-serif !important;
    width: 36px !important;
    height: 36px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding-top: 4px;
  }

  &.ant-steps-horizontal {
    .ant-steps-item-tail {
      margin-top: 2px !important;
      padding: 0 16px 0 20px !important;
    }
  }

  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background-color: ${color.primary} !important;
    border-color: ${color.primary} !important;
  }
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon {
    color: ${color.white} !important;
    font-weight: 600 !important;
  }

  .ant-steps-item .ant-steps-item-wait {
    background-color: ${color.white} !important;

    :hover {
      color: ${color.primary} !important;
    }
  }
  .ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-icon {
    background-color: ${color.white} !important;
    border-color: ${color.Text3} !important;
  }
  .ant-steps-item-finish .ant-steps-item-icon {
    background-color: ${color.primary} !important;
  }
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: ${color.white} !important;
  }

  .ant-steps-item-container {
    .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
      color: ${color.Text3} !important;
      font-weight: 600;
      background-color: ${color.white} !important;
    }
    :hover {
      color: ${color.primary} !important;
    }
  }

  /* ด้านล่างทั้งหมดเป็น step แบบ vertical */
  &.ant-steps-vertical {
  .ant-steps-item-tail {
    margin-left: -4px !important;
    padding: 0 !important;
      &::after {
      width: 2px!important;
      background-color: ${color.background2} !important;
    }
  }
    
  --donut-size: 24px;
  --donut-ring: 7px;
  --donut-inner-size: calc(var(--donut-size) - var(--donut-ring) * 2);
  .ant-steps-item-icon {
    width: var(--donut-size) !important;
    height: var(--donut-size) !important;
    padding: 0 !important;
    background: transparent !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    position: relative !important;
    box-sizing: border-box !important;
    border: var(--donut-ring) solid ${color.Text3} !important;
  }
  .ant-steps-item-icon::after {
    content: "";
    width: var(--donut-inner-size);
    height: var(--donut-inner-size);
    border-radius: 50%;
    display: block;
    background: ${color.white};
    box-sizing: border-box;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  }
  /* (ยังไม่ถึง step) */
  .ant-steps-item-wait .ant-steps-item-icon {
    border-color: ${color.Text3} !important;
  }
  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon {
    color: ${color.Text3} !important;
  }

  /*(active) */
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    border-color: ${color.Text3} !important;
  }
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon::after {
    background: ${color.white};
  }
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon .ant-steps-icon {
    color: ${color.Text3} !important;
    font-weight: 600 !important;
  }

  /* ทำเสร็จแล้ว */
  .ant-steps-item-finish .ant-steps-item-icon {
    border-color: ${color.primary} !important;
  }
  .ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon {
    color: ${color.primary} !important;
  }
`;
interface Props extends React.ComponentProps<typeof Steps> {
  current?: number;
  onChange?: (current: number) => void;
}
function StepAntd({ current, ...props }: Props) {
  return <StepsStyled labelPlacement='vertical' {...props} current={current} />;
}

export default StepAntd;
